module.exports = __webpack_public_path__ + "images/notEnoughAwardPoint_db628cb.svg";